// extracted by mini-css-extract-plugin
export default {"title":"EditOEEConfigModal_title__uqaij","icon":"EditOEEConfigModal_icon__+xBdp"};